export function easeInOutSine(t) {
  return -0.5 * (Math.cos(Math.PI * t) - 1);
}

export function easeInOutQuad(x: number): number {
  return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
}
